// have to make sure 6d3a17f7-3ebc-4939-abf6-447cffebaafe mbrcardsId is made () fileId/logId/

import React, { useEffect, useState } from 'react';
import { Item, Image, Header, Table, Input, Message, Checkbox, Button, Dropdown, Container, Grid } from 'semantic-ui-react'


// import Messages from "../messages/Messages";

// import Chats from "../messages/Chats";
import UserCardsMessage from '../messages/UserCardsMessage'
import AddMemberGroup from './AddMemberGroup';
import { MyStore } from "../../../../services/Store"


import moment from 'moment'


// import firebase from "firebase/app";
// import "firebase/auth";
// import "firebase/functions";
// import "firebase/database";

// 6d3a17f7-3ebc-4939-abf6-447cffebaafe
// 'be8efb12-910e-47bd-a559-bc11844df4c6'

export function Step2a(props) {

    const [members, setMembers] = useState()
    const [length, setLength] = useState()
    const [currentGroup, setCurrentGroup] = useState({})
    const [leaders, setLeaders] = useState({})
    const [mbrProjects, setMbrProjects] = useState()
    
    const [currentCardId, setCurrentCardId] = useState()

    const [state, setState] = useState({
        visible: false
    })

    // const [role, setRole] = useState({})

    const [invites, setInvites] = useState()
    //  const [roleKeys, setRoleKeys] = useState()
    // const recipeKey = '-LwLujWwcsr6szQxZYer';
    const recipeKey = props.oid

    const databaseRef = MyStore.database().ref();

    // this.setState({data: data});

    let cg = []
    // useEffect(() => {
    //     MyStore.database().ref().child(`/groups/${recipeKey}`).on('value', snap => {
    //         // let groups = []
    //         console.log(snap.val())
    //         // cg = snap.val()
    //         setCurrentGroup((snap.val()))


    //         // let length = Object.keys(currentGroup.members).length

    //                     let myArr = []
    //                     console.log('----------- function 02 -------------')
    //                     for (const key in snap.val().members) {
    //                         myArr.push(Object.assign({}, snap.val().members[key]));
    //                     }
    //                     if (snap.val() != null) {
    //                         // users = myArr
    //                         cg = myArr
    //                         setMembers(cg)
    //                         // setState({myArr})
    //                     }
    //                     // else {
    //                     //   this.setState({
    //                     //     groups: []
    //                     //   })    
    //                     // }

    //                 });

    //       }, []);



    useEffect(() => {

//    console.log(props)

        MyStore.auth().onAuthStateChanged((user) => {
            if (user) {
                

                MyStore.database().ref().child(`/groups/${recipeKey}`).on('value', snap => {
                    // let groups = []
                    // console.log(snap.val())
                    // cg = snap.val()
                    setCurrentGroup((snap.val()))
                    // let length = Object.keys(currentGroup.members).length

                    let myArr = []
                    // console.log('----------- function 02 -------------')
                    // console.log(snap.val())

                    for (const key in snap.val().members) {
                        myArr.push(Object.assign({}, snap.val().members[key]));
                    }
                    if (snap.val() != null) {
                        // users = myArr
                        cg = myArr
                        setMembers(cg)
                        // setState({myArr})
                    }


                    let inviteArr = []
                    let temp_roles = []
                    let count = 0
                    let roleKey = 0
                    for (const key in snap.val().invites) {
                        const keyObject = snap.val().invites[key]
                        keyObject['role'] = ''
                        keyObject['key'] = count++
                        inviteArr.push(Object.assign({}, (keyObject)));
                        temp_roles.push(Object.assign({}, ({ role: '', key: roleKey++, uid: snap.val().invites[key].uid })));
                    }
                    if (snap.val().invites != null) {
                        setInvites(inviteArr)
                        // setRoleKeys(temp_roles)
                        // setState({myArr})
                    }


                    // else {
                    //   this.setState({
                    //     groups: []
                    //   })    
                    // }

                });




                // console.log(cg)


                // console.log(cg)
                // let authMembers = []
                // for (let item in cg) {
                //     console.log(cg[item].username)
                //     MyStore.database().ref().child(`/usernames/${cg[item].username}`).on('value', snap => {
                //         // console.log(snap.val())
                //         authMembers.push(snap.val())
                //     })

                //     // authMembers.push(MyStore.ref().child("usernames").child(cg[item].username))
                //     // console.log(item)
                // }






            }// end of if

            let currentUserUid = MyStore.auth().currentUser.uid
            // const filelogid = '6d3a17f7-3ebc-4939-abf6-447cffebaafe'
            const filelogid = props.filelogid
            const oid = props.oid

            MyStore.database().ref().child(`/groups/${oid}`).child('mbrcards').child(filelogid).on('value', snap => {
                console.log(snap.val())

                let myArr = []
                // console.log('----------- function 02 -------------')
                // console.log(snap.val())

                for (const key in snap.val()) {
                    myArr.push(Object.assign({}, snap.val()[key]));
                }
                if (snap.val() != null) {
                    // users = myArr
                    // cg = myArr/
                    setMbrProjects(myArr)
                    // console.log(myArr)
                    // setState({myArr})
                }


            })

            // MyStore.database().ref().child(`/groups/${recipeKey}`).child('mbprojects').child(currentUserUid).on('value', snap => {
            //     console.log(snap.val())

            // })

        })



    }, []);


    //    setLength(Object.keys(currentGroup.members).length)

    // console.log('------  currentGroup.members  line 52-------------')
    // console.log( currentGroup.members)
    // console.log(Object.keys(members).length)
    // console.log(members)

    if (props.currentStep !== 2) {
        return null
    }


    const displayUsers = () =>

        length > 0 &&
        (currentGroup.members).map(m => (
            <React.Fragment>
                {/* {console.log(m)} */}
                {/* <Message key={m.id} message={m} user={this.state.currentUser} /> */}
            </React.Fragment>


        ));



    let listMembers = ''

    const handleContactsClick = (value) => {
        // console.log(value)
        // handleAddContactsMembers(value)
    }

    const handleClick = (value) => {
        // console.log(value)
        handleAddCadreMembers(value)
    }



    const handleAddCadreMembers = (key) => {
        // console.log(typeof(role))
        // console.log('--------------  handleInvites -----------------')
        // console.log(props)

        // if (roleKeys[key].role == "") {
        //     return
        // }

        // console.log(invites[key])
        const tempInvite = members[key]

        // console.log(members[key])
        // const tempInvite = invites[roles.key]

        const inivitedUser = {
            avatar: tempInvite.avatar,
            uid: tempInvite.uid,
            username: tempInvite.username,
            displayName:  tempInvite.displayName,
            role: tempInvite.role,
            // role: roleKeys[key].role,
            timestamp: Date.now(),
            momentTimestamp: moment().format('LLL')
        }
        // console.log(inivitedUser)

        // const cardId = '-M0a4x5v51tgt9HL6OET'

        if(props.cardId !== undefined && props.filelogid!== undefined){
            // console.log(props)
            setCurrentCardId(props.cardId)
            const cardId = props.cardId

            const currentMbrProjects = {
                id: cardId, 
                isMember: true,
            }
            // const filelogid = '6d3a17f7-3ebc-4939-abf6-447cffebaafe'
    
            const filelogid = props.filelogid
            // console.log('filesGroupId')
            // console.log(filelogid)
            // console.log(props.filelogid)
            databaseRef.child(`/groups/${props.oid}`).child('mbrcards').child(filelogid).child(inivitedUser.uid).set(inivitedUser)
            databaseRef.child(`/groups/${props.oid}`).child('mbrprojects').child(inivitedUser.uid).child('cards').child(filelogid).set(currentMbrProjects)
            
            
        }
       
        
        // const currentGroup = databaseRef.child('groups/' + oid + '/members')

        // currentGroup.child(inivitedUser.uid).set(inivitedUser);
        
        // databaseRef.child(`/groups/${recipeKey}`).child('mbrcards').child('6d3a17f7-3ebc-4939-abf6-447cffebaafe').on('value', snap => {
        //     console.log(snap.val())
        //     // snap.val().set(inivitedUser);
        // })

        // const testing =  databaseRef.child('groups/' + oid + '/testing')

        // const currentGroup = databaseRef.child('groups/' + oid + '/members')

        // currentGroup.child(inivitedUser.uid).set(inivitedUser);


        // console.log(inivitedUser)

        // if (typeof (role) == 'object') {
        //     // console.log(' if(typeof(role) == object){')
        //     return
        // }
        // else if (typeof (role) == 'string' && role != '') {

        // const currentGroup = databaseRef.child('groups/' + oid + '/members')

        // currentGroup.on('value', snap => {

        //     let myArr = []
        //     console.log('----------- function 01 -------------')
        //     for (const key in snap.val()) {

        //     }
        //     if (snap.val() != null) {
        //         // this.setState({
        //         //   files: myArr
        //         // }) 
        //         console.log('if')
        //     }
        //     else {
        //         // this.setState({
        //         //   files: []
        //         // })
        //         console.log('else')
        //     }

        // })
        // }
    }


    // if (members && currentGroup) {

    //     console.log(members)



    //     listMembers = members.map((member) =>
    //         <Table.Row key={member.username}>
    //             <Table.Cell collapsing>
    //                 <Checkbox toggle />
    //             </Table.Cell>
    //             <Table.Cell>{member.username}</Table.Cell>

    //         </Table.Row>
    //     );
    // }



    // console.log('------------ state -----------')

    // console.log(currentGroup)
    // console.log(currentGroup.currentUsers)
    // console.log(members)
    if (members && currentGroup) {
        // console.log(members)
        // console.log(Object.keys(currentGroup.members).length)

    }


    // const roleOptions = [
    //     { key: 1, text: 'administrator', value: 'administrator' },
    //     { key: 2, text: 'clinician', value: 'clinician' },
    //     { key: 3, text: 'coordinator', value: 'coordinator' },
    // ]


    // const dropdownExampleSelection = (key) => (
    //     <Dropdown
    //         placeholder='Select a Role'
    //         clearable
    //         selection
    //         //   defaultValue={serviceOptions[0].text}
    //         options={roleOptions}
    //         onChange={(e, { value }) => console.log(value, key)} />)


    const displayCadreMembers = () => {
        const currentInvite = []
        if (typeof (members) == 'object') {
            return (
                Array.from(members.keys()).map(key => (
                    <Table.Row key={key} style={{ minHeight: '1vh' }}  >
                        {/* {console.log(' key in display cadre members ')}
                        {console.log(key)} */}
                        <Table.Cell style={{ width: '1px' }} >
                            <Header as='h1' image>
                                <Image src={members[key].avatar} width="64" height="64"  ></Image>
                            </Header>
                        </Table.Cell>
                        <Table.Cell style={{ width: '13vh' }}> <b> {members[key].displayName}</b> <br></br>{members[key].username}  </Table.Cell>
                        <Table.Cell style={{ width: '13vh' }}>


                            <b>{members[key].role}{'   '}</b>


                        </Table.Cell>
                        <Table.HeaderCell style={{ width: '3vh' }} >
                            <Button icon='add user' size='large'
                                value={key}
                                onClick={() => handleClick(key)}
                            >
                            </Button> </Table.HeaderCell>
                    </Table.Row>
                ))
            )
        }
    }

    const displayCurrentMembers = () => {
        const currentInvite = []
        if (typeof (mbrProjects) == 'object') {
            return (
                Array.from(mbrProjects.keys()).map(key => (
                    <Table.Row key={key} style={{ minHeight: '1vh' }}  >
                        <Table.Cell style={{ width: '1px' }} >
                            <Header as='h1' image>
                                <Image src={mbrProjects[key].avatar} width="64" height="64"  ></Image>
                            </Header>
                        </Table.Cell>
                        <Table.Cell style={{ width: '13vh' }}> <b> {mbrProjects[key].displayName}</b> <br></br>{mbrProjects[key].username}  </Table.Cell>
                        <Table.Cell style={{ width: '13vh' }}>


                            <b>{mbrProjects[key].role}{'   '}</b>


                        </Table.Cell>
                        <Table.HeaderCell style={{ width: '3vh' }} >
                            <Button icon='add user' size='large'
                                value={key}
                                onClick={() => handleClick(key)}
                            >
                            </Button> </Table.HeaderCell>
                    </Table.Row>
                ))
            )
        }
    }



    // const paragraph = <Image src='https://react.semantic-ui.com/images/wireframe/short-paragraph.png' />

    return (
        <div style={{ padding: "0px" }}>

            <Header as='h1' textAlign='center'> Delivery</Header>
            <Container style={{}} className='mbrProjects'>



                <AddMemberGroup
                    currentGroup={currentGroup}
                    currentUser={MyStore.auth().currentUser}
                    isDM={false}
                    leaders={currentGroup.currentUsers
                
                        // leaders={MyStore.database().ref().child("usernames")

                    }
                    filelogid={props.filelogid}
                />
{/* 
                {console.log('------ line 401 ')}
                {console.log(mbrProjects)}
                {console.log(MyStore.auth().currentUser.uid)} */}


            {mbrProjects=== undefined ? null: 
            
            <UserCardsMessage 
            filelogid={props.filelogid}
            cardId = {props.cardId}
          members={mbrProjects}
          key={mbrProjects.keys()}
          ></UserCardsMessage>
            }
      
            </Container>


            {/* 
            <UserCardsMessage members = {members}></UserCardsMessage> */}
            <div className="form-group">


                {/* <Table inverted textAlign='center'  
                    style={{
                        background: "transparent",
                        border: "1px solid black",
                        boxShadow: "none",
                        padding: "0em 0em",
                        textAlign: 'justified',
                    }}

                >
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell style={{ width: '1px' }} />
                            <Table.HeaderCell style={{ width: '25vh' }}><Header>Member</Header></Table.HeaderCell>
                            <Table.HeaderCell ><Header>Role</Header></Table.HeaderCell>
                            <Table.HeaderCell style={{ width: '1px' }} />
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>
                    

                    {displayMbrMembers()}

                    </Table.Body>
                </Table>
                     */}


                <Container className='cadreMembersTable'>

                    <Table textAlign='center' inverted color={'teal'}
                        style={{
                            // background: "transparent",
                            border: "3px solid #00D6CD",
                            boxShadow: "none",
                            padding: "0em 0em",
                            textAlign: 'justified',
                            minHeight: '45vh'
                        }}

                    >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell style={{ width: '1px' }} />
                                <Table.HeaderCell style={{ width: '20h' }}><Header style={{ color: 'white' }}> Cadre Members</Header></Table.HeaderCell>
                                <Table.HeaderCell ><Header style={{ color: 'white' }}>Role</Header></Table.HeaderCell>
                                <Table.HeaderCell style={{ width: '1px' }} />
                            </Table.Row>
                        </Table.Header>

                        <Table.Body>
                            {/* {displayCurrentMembers()} */}
                            {displayCadreMembers()}
                            {/* {displayCadreMembers()}
                    {displayCadreMembers()}
                            {displayCadreMembers()} */}
                        </Table.Body>
                    </Table>


                </Container>



            


                    {state.visible ? (
                            <Container className='contactMembersTable'>
                        <Table inverted color={'blue'} textAlign='center'
                            style={{
                                // background: "transparent",
                                border: "3px solid #3AC0FF",
                                boxShadow: "none",
                                padding: "0em 0em",
                                textAlign: 'justified',
                                minHeight: '45vh'

                            }}

                        >
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell style={{ width: '1px' }} />
                                    <Table.HeaderCell style={{ width: '25vh' }}><Header style={{ color: 'white' }}>Contacts</Header></Table.HeaderCell>
                                    <Table.HeaderCell ><Header style={{ color: 'white' }}>Role</Header></Table.HeaderCell>
                                    <Table.HeaderCell style={{ width: '1px' }} />
                                </Table.Row>
                            </Table.Header>

                            <Table.Body>



                                {/* {displayCadreMembers()} */}
                                {/* {displayCadreMembers()}
                {displayCadreMembers()} */}
                            </Table.Body>
                        </Table>
                                </Container>
                    ) : null
                    }




        









                {/* <UserCardsMessage members={members} 
                // key={members}
                ></UserCardsMessage> */}
                {/* <UserCardsMessage  ></UserCardsMessage> */}

                {/* <Table celled padded   style={{
                                 background: "transparent",
                                 border: "1px solid transparent",
                                 boxShadow: "none",
                                 padding: "0em 0em",
                }}>
                <Table.Body> */}

                {/* <Table.Row >
                        <Table.Cell style={{ padding: "40px" }} >
                            <Header as='h4' textAlign='center'>

                            </Header>
                        </Table.Cell>
                        <Table.Cell >
                            <Message
                                icon='inbox'
                                header='Add Members?'
                                content='Would you like to add other members in your organization to this project?' />

                        </Table.Cell>
                    </Table.Row>


                    <Table.Row>
                        <Table.Cell style={{ padding: "40px" }} >
                            <Header as='h4' textAlign='center'>
                                Email:
                                </Header>
                        </Table.Cell>

                        <Table.Cell ><Input data-field="email" onChange={props.handleChange} value={props.email} id='email'
                            name='email' size='huge' placeholder='coworker@email.com' style={{ width: "400px" }} />
                            <Button style={{ marginLeft: '30px' }} size='small'>Enter email</Button>
                        </Table.Cell>

                    </Table.Row> */}
                {/* </Table.Body>
            </Table>  */}
                {/* <Table>
                <Table.Body>
                    <Table.Row >
                        <Table.Cell style={{ padding: "40px" }} >
                            <Header as='h4' textAlign='center'>

                            </Header>
                        </Table.Cell>
                        <Table.Cell >
                            <Message
                                icon='inbox'
                                header='Add Members?'
                                content='Would you like to add other members in your organization to this project?' />

                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>


             



{/* 
                return (
      <Message warning icon='user md'
        header='Healthcare Brief'
        content='Create a Draft Project'></Message>) */}





                {/* <List>
                                {users && this.displayPostLeaders(users)}
                            </List> */}

                {/* <label htmlFor="heading">Heading</label>
        <input
            className="form-control"
            id="heading"
            name="heading"
            type="text"
            placeholder="Enter heading"
            value={props.heading}
            onChange={props.handleChange}
            /> */}



                {/* <br></br><br></br>    <br></br><br></br>     <br></br><br></br> */}

            </div>
            {/* <UserCardsMessage></UserCardsMessage> */}

            {/* <Message style={{
                background: "transparent",
                border: "1px solid transparent",
                boxShadow: "none",
                padding: "0em 0em",
            }}
            ></Message> */}

            {/*          <Messages
                key={MyStore.database().ref("groups").child("-LwLokoEOlo2jFZHUsDJ") && "-LwLokoEOlo2jFZHUsDJ"}
                currentGroup={currentGroup}
                currentUser={MyStore.auth().currentUser}
                isDM={false}
                />*/}

            {/* <Chats
                key={MyStore.database().ref("groups").child("-LwLokoEOlo2jFZHUsDJ") && "-LwLokoEOlo2jFZHUsDJ"}
                currentGroup={currentGroup}
                currentUser={MyStore.auth().currentUser}
                isDM={false}
            /> */}

            {/* <Chats
                key={MyStore.database().ref("groups").child("-LwLokoEOlo2jFZHUsDJ").child('chats').child('7e6096da-1062-42e1-8799-32dba9a3d7ba') && "-LwLokoEOlo2jFZHUsDJ"}
                currentGroup={currentGroup}
                currentUser={MyStore.auth().currentUser}
                isDM={false}
                /> */}
        </div>
    );
}


// key={currentGroup && currentGroup.id}
// currentGroup={currentGroup}
// currentUser={currentUser}
// isDM={isDM}



// auth.localId

// -LwLujWwcsr6szQxZYer



{/* <Messages
key={MyStore.database().ref("groups").child("-LwLujWwcsr6szQxZYer") && "-LwLujWwcsr6szQxZYer"}
currentGroup={MyStore.database().ref("groups").child("-LwLujWwcsr6szQxZYer")}
currentUser={MyStore.auth().currentUser}
isDM={false}
/> */}